






import { Component, Vue, Prop } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import Highcharts from 'highcharts';

@Component
export default class MultiLabelBarChart extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    @Prop(String) name: string;
    @Prop({ default: () => {} }) data: { [key: string]: any };
    @Prop(String) selector: string;
    @Prop() labels: any[];
    @Prop(String) legendTitle: string;
    @Prop({ default: () => [] }) categories: string[];

    /*----------------------------------*
     * Data
     *-----------------------------------*/

    /*----------------------------------*
     * Computed
     *-----------------------------------*/

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        this.drawChart();
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    private drawChart() {
        // 表示データ抽出
        // ラベルの文だけseries用データ構造を作成
        const series = [];
        for (let i = 0; i < this.labels.length; i++) {
            series.push({
                name: this.labels[i],
                data: [],
                color: this.labels[i] == 1 ? SC.Color.POSITIVE : SC.Color.NEGATIVE,
            });
        }

        // this.data は カテゴリ × ラベル のマトリクス
        // カテゴリとはそのカラムで使用された値の種類
        for (let i = 0; i < this.categories.length; i++) {
            const category: string = this.categories[i];
            for (let k = 0; k < this.labels.length; k++) {
                const label = this.labels[k];
                if (label in this.data[category]) {
                    series[k].data.push(this.data[category][label]);
                } else {
                    series[k].data.push(0);
                }
            }
        }

        // 描画設定
        const chartParam: { [key: string]: any } = {
            chart: {
                type: 'column',
            },
            credits: {
                enabled: false,
            },
            title: {
                text: '',
            },

            xAxis: [
                {
                    categories: this.categories,
                },
            ],
            yAxis: {
                min: 0,
                title: {
                    text: '',
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color:
                            // theme
                            (Highcharts.defaultOptions.title.style &&
                                Highcharts.defaultOptions.title.style.color) ||
                            'gray',
                    },
                },
            },
            legend: {
                title: {
                    text: this.legendTitle,
                },
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true,
                    },
                },
            },
            series: series,
        };
        Highcharts.chart(this.selector, chartParam);
    }
}
